import { useSelector } from 'react-redux';
import FormField from '../../../ui/formField';
import ParterDetails from './PartnerDetails';

const PartnershipSection = (props) => {
  const fieldData = useSelector((state) => state.policyOwnerData);
  const { loading, error, poData } = fieldData;
  const onPartnershipSectionFieldsChange = (event) => {
    props.setPartnershipSectionFields((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const onPartnershipAddressFieldsChange = (event) => {
    props.setPartnershipAddressFields((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const onPartnershipContactDetailsFieldsChange = (event) => {
    props.setPartnershipContactDetailsFields((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <>
      {poData?.data && (
        <>
          <div className="flex">
            {poData?.data?.partnershipSectionFields?.map((item) => {
              return (
                <FormField
                  key={item.id}
                  label={item.label}
                  id={item.id}
                  value={item.value}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  min={item.min}
                  max={item.max}
                  layoutType={item.layoutType}
                  onChangeHandler={onPartnershipSectionFieldsChange}
                  selectOptions={item.selectOptions}
                  regex={item?.regex}
                  errorMessage={item?.errorMessage}
                  validationType={item?.validationType}
                />
              );
            })}
          </div>
          <div className="line-separation"></div>
          <h3 id={poData?.data?.partnershipAddressLabel.id}>
            {poData?.data?.partnershipAddressLabel.label}
          </h3>
          <div className="flex">
            {poData?.data?.partnershipAddressFields.map((item) => {
              return (
                <FormField
                  key={item.id}
                  label={item.label}
                  id={item.id}
                  value={item.value}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  min={item.min}
                  max={item.max}
                  layoutType={item.layoutType}
                  onChangeHandler={onPartnershipAddressFieldsChange}
                  selectOptions={item.selectOptions}
                  regex={item?.regex}
                  errorMessage={item?.errorMessage}
                  dropdownType={item.dropdownType}
                />
              );
            })}
          </div>
          <div className="line-separation"></div>
          <h3 id={poData?.data?.partnershipContactDetailsLabel?.id}>
            {poData?.data?.partnershipContactDetailsLabel?.label}
          </h3>
          <div className="flex">
            {poData?.data?.partnershipContactDetailsFields?.map((item) => {
              return (
                <FormField
                  key={item.id}
                  label={item.label}
                  id={item.id}
                  value={item.value}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  min={item.min}
                  max={item.max}
                  layoutType={item.layoutType}
                  onChangeHandler={onPartnershipContactDetailsFieldsChange}
                  selectOptions={item.selectOptions}
                  regex={item?.regex}
                  errorMessage={item?.errorMessage}
                  dropdownType={item.dropdownType}
                />
              );
            })}
          </div>
          <div className="line-separation"></div>
          <ParterDetails
            partners={props.partners}
            setPartners={props.setPartners}
          />
        </>
      )}
    </>
  );
};

export default PartnershipSection;
